import { jsPDF } from 'jspdf';
import Logo from '../../../assets/Logo-Negro.png';

/**
 * Genera un PDF de informe con formato profesional y formal
 * Basado en el formato estándar de notificaciones de empresa
 */
export const generateInformePDFMejorado = async ({
  informeNumero = '',
  lugarControl = '',
  fecha = '',
  hora = '',
  actuante = '',
  motivo = '',
  motivoDetalle = '',
  empleado = '',
  legajo = '',
  nroCoche = '',
  linea = '',
  servicio = '',
  horaNotificacion = '',
  descargoTexto = '',
  fechaRespuesta = '',
  firmaEmpleadoBase64 = '',
  firmaInspectorBase64 = '',
  firmaGerenteBase64 = ''
}) => {
  try {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    const marginLeft = 15;
    const marginRight = 15;
    const contentWidth = pageWidth - marginLeft - marginRight;
    let y = 15;

    // ==================== ENCABEZADO ====================
    const logoImg = new Image();
    logoImg.src = Logo;
    await new Promise(resolve => { logoImg.onload = resolve; });
    doc.addImage(logoImg, 'PNG', marginLeft, y, 35, 17);

    // Título principal
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(16);
    doc.text('INFORME DE SERVICIO', pageWidth / 2, y + 8, { align: 'center' });
    
    // Número de informe en esquina superior derecha
    doc.setFontSize(12);
    doc.text(`N° ${String(informeNumero || '0').padStart(4, '0')}`, pageWidth - marginRight, y + 5, { align: 'right' });

    y += 25;

    // Línea divisoria
    doc.setLineWidth(0.8);
    doc.line(marginLeft, y, pageWidth - marginRight, y);
    y += 8;

    // ==================== DATOS DEL INFORME ====================
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);

    const fechaFormateada = fecha ? new Date(fecha).toLocaleDateString('es-AR') : '';
    
    // Datos en dos columnas
    const col1X = marginLeft;
    const col2X = pageWidth / 2 + 5;
    const lineHeight = 6;

    doc.setFont('helvetica', 'bold');
    doc.text('Lugar de Control:', col1X, y);
    doc.setFont('helvetica', 'normal');
    doc.text(String(lugarControl || 'N/A'), col1X + 35, y);

    doc.setFont('helvetica', 'bold');
    doc.text('Fecha:', col2X, y);
    doc.setFont('helvetica', 'normal');
    doc.text(fechaFormateada, col2X + 15, y);
    y += lineHeight;

    doc.setFont('helvetica', 'bold');
    doc.text('Hora:', col1X, y);
    doc.setFont('helvetica', 'normal');
    doc.text(String(hora || 'N/A'), col1X + 35, y);

    doc.setFont('helvetica', 'bold');
    doc.text('Línea:', col2X, y);
    doc.setFont('helvetica', 'normal');
    doc.text(String(linea || 'N/A'), col2X + 15, y);
    y += lineHeight;

    doc.setFont('helvetica', 'bold');
    doc.text('Coche N°:', col1X, y);
    doc.setFont('helvetica', 'normal');
    doc.text(String(nroCoche || 'N/A'), col1X + 35, y);

    doc.setFont('helvetica', 'bold');
    doc.text('Servicio:', col2X, y);
    doc.setFont('helvetica', 'normal');
    doc.text(String(servicio || 'N/A'), col2X + 15, y);
    y += lineHeight + 2;

    // ==================== DATOS DEL EMPLEADO ====================
    doc.setLineWidth(0.3);
    doc.line(marginLeft, y, pageWidth - marginRight, y);
    y += 5;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text('DATOS DEL EMPLEADO', marginLeft, y);
    y += 6;

    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text('Legajo N°:', col1X, y);
    doc.setFont('helvetica', 'normal');
    doc.text(String(legajo || 'N/A'), col1X + 20, y);

    doc.setFont('helvetica', 'bold');
    doc.text('Nombre:', col2X, y);
    doc.setFont('helvetica', 'normal');
    doc.text(String(empleado || 'N/A'), col2X + 18, y);
    y += lineHeight + 3;

    // ==================== MOTIVO ====================
    doc.setLineWidth(0.3);
    doc.line(marginLeft, y, pageWidth - marginRight, y);
    y += 5;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text('MOTIVO DEL INFORME', marginLeft, y);
    y += 6;

    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text(String(motivo || 'N/A'), marginLeft, y);
    y += lineHeight;

    // Detalle del motivo en caja
    doc.setFont('helvetica', 'normal');
    const motivoLines = doc.splitTextToSize(
      String(motivoDetalle || 'Sin detalle registrado'), 
      contentWidth - 6
    );
    const motivoBoxHeight = Math.max(motivoLines.length * 5 + 8, 25);
    
    doc.setLineWidth(0.3);
    doc.rect(marginLeft, y, contentWidth, motivoBoxHeight);
    doc.text(motivoLines, marginLeft + 3, y + 5);
    y += motivoBoxHeight + 5;

    // ==================== ACTUANTE ====================
    doc.setFont('helvetica', 'bold');
    doc.text('Inspector actuante:', marginLeft, y);
    doc.setFont('helvetica', 'normal');
    doc.text(String(actuante || 'N/A'), marginLeft + 40, y);
    y += lineHeight + 5;

    // ==================== NOTIFICACIÓN ====================
    doc.setLineWidth(0.3);
    doc.line(marginLeft, y, pageWidth - marginRight, y);
    y += 5;

    const fechaDescargo = fechaRespuesta ? new Date(fechaRespuesta) : new Date();
    const fechaDesc = fechaDescargo.toLocaleDateString('es-AR');
    const horaDesc = fechaDescargo.toLocaleTimeString('es-AR', { hour: '2-digit', minute: '2-digit' });

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text('NOTIFICACIÓN', marginLeft, y);
    y += 6;

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    const notificacionTexto = `Siendo las ${horaDesc} hs. del día ${fechaDesc}, me notifico del presente informe conforme `;
    const notificacionTexto2 = `lo establece el Convenio Colectivo de Trabajo y el Reglamento Interno de la empresa.`;
    doc.text(notificacionTexto, marginLeft, y);
    y += lineHeight;
    doc.text(notificacionTexto2, marginLeft, y);
    y += lineHeight + 8;

    // ==================== DESCARGO DEL EMPLEADO ====================
    doc.setLineWidth(0.3);
    doc.line(marginLeft, y, pageWidth - marginRight, y);
    y += 5;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(11);
    doc.text('DESCARGO DEL EMPLEADO', marginLeft, y);
    y += 6;

    doc.setFont('helvetica', 'italic');
    doc.setFontSize(9);
    doc.text('(Dispone de 48hs hábiles para realizar su descargo desde la notificación)', marginLeft, y);
    y += 5;

    // Caja de descargo - más grande para aprovechar espacio
    const espacioRestante = pageHeight - y - 60; // Reservar espacio para firmas
    const descargoBoxHeight = Math.max(espacioRestante * 0.6, 50);

    doc.setLineWidth(0.3);
    doc.rect(marginLeft, y, contentWidth, descargoBoxHeight);

    if (descargoTexto && descargoTexto.trim()) {
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(10);
      const descargoLines = doc.splitTextToSize(String(descargoTexto), contentWidth - 6);
      doc.text(descargoLines, marginLeft + 3, y + 5);
    } else {
      // Líneas para escribir a mano
      doc.setLineWidth(0.1);
      doc.setDrawColor(180, 180, 180);
      const numLineas = Math.floor(descargoBoxHeight / 6) - 1;
      for (let i = 1; i <= numLineas; i++) {
        const lineY = y + (i * 6);
        doc.line(marginLeft + 2, lineY, pageWidth - marginRight - 2, lineY);
      }
      doc.setDrawColor(0, 0, 0);
    }

    y += descargoBoxHeight + 10;

    // ==================== FIRMAS ====================
    const firmaAreaHeight = 35;
    const firmaWidth = (contentWidth - 10) / 3; // 3 firmas con espaciado

    // Firma Empleado Notificado
    const firma1X = marginLeft;
    if (firmaEmpleadoBase64) {
      try {
        doc.addImage(firmaEmpleadoBase64, 'PNG', firma1X + 5, y, firmaWidth - 10, 20);
      } catch (e) {
        console.warn('Error al cargar firma empleado:', e);
      }
    }
    doc.setLineWidth(0.3);
    doc.line(firma1X, y + firmaAreaHeight - 15, firma1X + firmaWidth, y + firmaAreaHeight - 15);
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8);
    doc.text('FIRMA Y ACLARACIÓN', firma1X + firmaWidth / 2, y + firmaAreaHeight - 10, { align: 'center' });
    doc.text('EMPLEADO NOTIFICADO', firma1X + firmaWidth / 2, y + firmaAreaHeight - 6, { align: 'center' });

    // Firma Inspector
    const firma2X = marginLeft + firmaWidth + 5;
    if (firmaInspectorBase64) {
      try {
        doc.addImage(firmaInspectorBase64, 'PNG', firma2X + 5, y, firmaWidth - 10, 20);
      } catch (e) {
        console.warn('Error al cargar firma inspector:', e);
      }
    }
    doc.line(firma2X, y + firmaAreaHeight - 15, firma2X + firmaWidth, y + firmaAreaHeight - 15);
    doc.text('FIRMA Y ACLARACIÓN', firma2X + firmaWidth / 2, y + firmaAreaHeight - 10, { align: 'center' });
    doc.text('INSPECTOR/SUPERVISOR', firma2X + firmaWidth / 2, y + firmaAreaHeight - 6, { align: 'center' });

    // Firma Gerente/RRHH
    const firma3X = marginLeft + (firmaWidth + 5) * 2;
    if (firmaGerenteBase64) {
      try {
        doc.addImage(firmaGerenteBase64, 'PNG', firma3X + 5, y, firmaWidth - 10, 20);
      } catch (e) {
        console.warn('Error al cargar firma gerente:', e);
      }
    }
    doc.line(firma3X, y + firmaAreaHeight - 15, firma3X + firmaWidth, y + firmaAreaHeight - 15);
    doc.text('FIRMA Y ACLARACIÓN', firma3X + firmaWidth / 2, y + firmaAreaHeight - 10, { align: 'center' });
    doc.text('GERENCIA / RRHH', firma3X + firmaWidth / 2, y + firmaAreaHeight - 6, { align: 'center' });

    // ==================== PIE DE PÁGINA ====================
    y = pageHeight - 10;
    doc.setFont('helvetica', 'italic');
    doc.setFontSize(7);
    doc.setTextColor(100, 100, 100);
    doc.text(
      'Este documento es de carácter confidencial y su contenido está sujeto a las disposiciones del CCT vigente.',
      pageWidth / 2,
      y,
      { align: 'center' }
    );

    // ==================== GENERAR PDF ====================
    const pdfBlob = doc.output('blob');
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, '_blank');

    return { blob: pdfBlob, url: pdfUrl };
  } catch (error) {
    console.error('Error al generar el PDF del informe:', error);
    throw error;
  }
};
